import { PreparedDestination } from "@prequel/react";

import axios, { ApiResponse, AppError, ErrorResponse } from "@/api/client";
import { MagicLinkArgs } from "@/api/services/magic-links";

export type TestDestinationResponse = {
  status: "success" | "error";
  message?: string;
};

export type TestDestinationResult = {
  status: "success" | "error";
  message?: string;
};

const postDestination = async (payload: {
  magiclinkargs: MagicLinkArgs;
  destination: PreparedDestination;
}): Promise<void> => {
  const { magiclinkargs, destination } = payload;
  const environment = magiclinkargs.isProd ? "prod" : "staging";

  try {
    await axios.post(`/public/orgs/${magiclinkargs.orgID}/${environment}/magic-links/${magiclinkargs.linkID}/convert`, {
      destination: destination,
    });
  } catch (reason: any) {
    const errorResponse = reason as ErrorResponse;
    const e: AppError = {
      error: {
        message: errorResponse.response?.data?.message || "Destination creation failed.",
        suppressGlobalNotification: false,
        statusCode: errorResponse.response?.status,
      },
    };
    throw e;
  }
};

const postTestDestination = async (payload: {
  magiclinkargs: MagicLinkArgs;
  destination: PreparedDestination;
}): Promise<TestDestinationResult> => {
  const { magiclinkargs, destination } = payload;
  const environment = magiclinkargs.isProd ? "prod" : "staging";

  try {
    const response: ApiResponse<TestDestinationResponse> = await axios.post(
      `/public/orgs/${magiclinkargs.orgID}/${environment}/magic-links/${magiclinkargs.linkID}/test-connection`,
      {
        destination: destination,
      },
    );
    return {
      status: response.data.data?.status,
      message: response.data.message,
    };
  } catch (reason: any) {
    const errorResponse = reason as ErrorResponse;
    const e: AppError = {
      error: {
        message: errorResponse.response?.data?.message || "Destination connection test failed.",
        suppressGlobalNotification: false,
        statusCode: errorResponse.response?.status,
      },
    };
    throw e;
  }
};

const DestinationService = {
  postDestination,
  postTestDestination,
};

export default DestinationService;
